export default "/fonts/vendor/@fontsource/inter/files/inter-cyrillic-ext-400-normal.woff2?4543e27a05aa2ba75c44fe4973254e4a";